<template>
  <section>
    <div class="clearfix documentItem template">
      <div class="logo">
        <router-link
          :to="{ name: 'Template', params: { dclIdentity: details.documentVersion.dclIdentity }}"
        >
        <div class="cover-small">
          <div class="cover-image-container">
            <div class="cover-outer-align">
              <div class="cover-inner-align">
                <i class="fal fa-file-invoice fa-2x" />
              </div>
            </div>
          </div>
        </div>
        </router-link>        
      </div>
      <div class="information w-light">
        <router-link
          :to="{ name: 'Template', params: { dclIdentity: details.documentVersion.dclIdentity }}"
        >
          <h5>{{ details.document.name }} - Version {{ details.documentVersion.version }}</h5>
        </router-link>
        <small v-bind:class="{ 'd-block d-lg-none': !showMinimal }">
          {{ details.team }}
          <router-link
            :to="{ name: 'Template', params: { dclIdentity: details.documentVersion.dclIdentity }}"
          >
            <br />
            {{ details.documentVersion.dclIdentity }} 
            <span class="d-inline-block d-lg-none" v-if="!showMinimal">
              - {{ $moment(details.documentVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}
            </span>
          </router-link>
        </small>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell" v-if="!showMinimal">
        <router-link
            :to="{ name: 'Template', params: { dclIdentity: details.documentVersion.dclIdentity }}"
          >
           {{ details.documentVersion.dclIdentity }}
          </router-link>
      </div>
      <div class="information w-light d-none d-lg-table-cell" v-if="!showMinimal">
        <router-link
            :to="{ name: 'Template', params: { dclIdentity: details.documentVersion.dclIdentity }}"
          >
          {{ details.team }}
          </router-link>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell" v-if="!showMinimal">
        <router-link
            :to="{ name: 'Template', params: { dclIdentity: details.documentVersion.dclIdentity }}"
          >
          {{ $moment(details.documentVersion.publishedDate) | moment("YYYY-MM-DD HH:mm") }}
          </router-link>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ["item","small"],
  data() {
    return {
      selected: 0,
      details: this.item,
      showMinimal: this.small,
      publishedDetails: this.item,
      user: this.$store.getters["auth/user"]
    };
  },
  computed: {
    documentUrl() {
      return (
        process.env.VUE_APP_FRONTEND +
        "/template/" +
        this.details.documentVersion.dclIdentity
      );
    }
  }
};
</script>
<style>
</style>